import React, { Component } from 'react';
import parse from 'html-react-parser';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { fade, MenuItem, Modal, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import TablePagination from '@material-ui/core/TablePagination';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';

import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import PerfectScrollbar from 'react-perfect-scrollbar';
//import Calendar from './index';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { DatePicker } from '@material-ui/pickers';
import { dateDiffInDays, getMyDate2, myFormatDate2, myFormatPrice, myGetNumber } from '../../../@jumbo/utils/commonHelper';
import FormControl from '@material-ui/core/FormControl';
import MuiAlert from '@material-ui/lab/Alert';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import { injectIntl } from 'react-intl';
import Skeleton from '@material-ui/lab/Skeleton';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';

const style = {
  /*position: 'absolute',
  top: '50%',
  left: '50%',*/
  /* transform: 'translate(-50%, -50%)',*/
  '@media screen and (max-width: 800px)': {
    width: '100%',
  },
  '@media screen and (min-width: 800px)': {
    width: '100%',
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const rstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  '@media screen and (max-width: 800px)': {
    width: '95%',
  },
  '@media screen and (min-width: 800px)': {
    width: 600,
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function MyAlert(props) {
  return <MuiAlert elevation={6} variant="outlined" {...props} />;
}

const useStyles = theme => ({
  boxTop: {
    paddingTop: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  myButton: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },

  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
  table: {
    maxHeight: '50%',
  },
});

const DialogTitle = withStyles(useStyles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
}))(MuiDialogActions);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function getMyDate(prop) {
  var md = new Date(prop);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

class AddRoom extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    this.handleClose = this.handleClose.bind(this);
    this.checkDates = this.checkDates.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.getRoomPrice = this.getRoomPrice.bind(this);
    this.checkOffers = this.checkOffers.bind(this);
    this.useOffer = this.useOffer.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getCancelInfo = this.getCancelInfo.bind(this);
    this.showAvailableTerms = this.showAvailableTerms.bind(this);
    this.showAvailableTerms2 = this.showAvailableTerms2.bind(this);

    var roomCount2 = Array(100).fill(1);
    this.getCancelInfo2 = this.getCancelInfo2.bind(this);
    this.showChips = this.showChips.bind(this);
    this.getMealPlan = this.getMealPlan.bind(this);
    this.showRoomMessage = this.showRoomMessage.bind(this);
    this.showRoomMessage2 = this.showRoomMessage2.bind(this);

    this.state = {
      type: -1,
      rooms: 0,
      arrival: '',
      hideUnavailable: false,
      departure: '',
      hotelId: 0,
      changed: true,
      currentPrice: '',
      newPrice: '',
      confirm: false,
      adults: 0,
      children: 0,
      childAge2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      available: -1,
      appDiscount: 0,
      roomCount2: roomCount2,
      reason: '',
      discountMode: 1,
      childAge: '',
      currencyRatio: 1,
      guestCurrency: '',
    };
  }
  useOffer(sitem) {
    const myRoomCount = this.state.roomCount2[sitem.index];

    var hotelId = this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == sitem.roomId)[0].hotelid;
    var xc = this.props.auth.authUser.currencies[0].code;
    if (sitem.currency != null) xc = sitem.currency;

    if (this.state.rooms < 0) return;
    if (getMyDate(this.state.arrival) >= getMyDate(this.state.departure)) return;
    const { intl } = this.props;
    //this.props.moveFolio(this.state.folioId);
    const token = localStorage.getItem('token');
    var pmsUrl = `https://secure.webbookingpro.com/api/pms.php`;

    var newroominfo = {
      reservationId: this.props.resRoom.id,
      roomId: sitem.roomId,
      hotelId: this.state.hotelId,
      roomCount: myRoomCount,
      policyId: sitem.policyId,
      customPolicyId: sitem.customPolicyId,
      serviceId: sitem.serviceId != null ? sitem.serviceId : null,
      packageId: sitem.packageId != null ? sitem.packageId : null,
      rateId: sitem.rateId != null ? sitem.rateId : null,
      //room_info: sitem.room_info,
      discount: 0,
      price: sitem.priceFinal,
      guestCurrency: xc,
      checkIn: getMyDate(this.state.arrival),
      checkOut: getMyDate(this.state.departure),
      guestAdults: this.state.adults,
      guestChildren: this.state.children,
      childAge: JSON.parse(JSON.stringify(this.state.childAge2)),
    };
    if (newroominfo.rateId == null && newroominfo.packageId == null) newroominfo.rateId = 0;
    if (newroominfo.packageId == null) newroominfo.packageId = 0;
    if (newroominfo.packageId != null && newroominfo.packageId != 0) newroominfo.rateId = 0;
    console.log(newroominfo);

    const senddata = {
      Action: 'addroom',
      token: token,
    };
    senddata.Data = newroominfo;
    axios.post(pmsUrl, senddata).then(res => {
      //if (this.props.setState2 != null) this.props.setState2({ resDetailsVisible: false });
      if (this.props.setState2 != null) this.props.setState2({ lastEvents: [], running2: false });
      this.props.doRefresh();
      //if (this.props.doRefresh != null) this.props.doRefresh();
      this.props.setState({ addRoomVisible: false });
      if (this.props.doRefresh2 != null) this.props.doRefresh2();
    });
  }
  getRoomPrice(price, currency = null) {
    price = price * this.state.currencyRatio;
    var xcurrency = this.state.guestCurrency;
    if (currency != null) xcurrency = currency;
    var res = myFormatPrice(price, this.props.auth.authUser.numberMode) + ' ' + xcurrency;
    //if (this.state.hotelid == 18) res += ' (' + formatPrice(price * 7.5345, 'en') + ' ' + 'HRK)';
    return res;
  }

  showRoomMessage(data) {
    if (data == 0)
      return (
        <>
          <MyAlert severity="warning">
            <IntlMessages id="_NO_AVAILABLE_ROOMS" />
          </MyAlert>
          <br />
        </>
      );
  }

  showRoomMessage2(data) {
    if (data < 10) {
      if (data == 1)
        return (
          <>
            <MyAlert severity="warning">
              <IntlMessages id="error4" />
            </MyAlert>
            <br />
          </>
        );

      if (data == 2)
        return (
          <>
            <MyAlert severity="warning">
              <IntlMessages id="error5" />
            </MyAlert>
            <br />
          </>
        );
    }
    if (data >= 10 && data < 100) {
      return (
        <>
          <MyAlert severity="warning">
            <IntlMessages id="_MSN_MINIMUM_NIGHTS" />
            {': '}
            {data - 10}
          </MyAlert>
          <br />
        </>
      );
    }
    if (data >= 100 && data < 1000) {
      return (
        <>
          <MyAlert severity="warning">
            <IntlMessages id="_MSN_MAXIMUM_NIGHTS" />
            {': '}
            {data - 100}
          </MyAlert>
          <br />
        </>
      );
    }

    return null;
  }

  showAvailableTerms(data, simple = false) {
    //console.log('showavailableerms');
    console.log(data);
    const locale = this.state.offerLanguage;
    var result = '';
    var res = data.map(
      function(item) {
        var today = new Date(item.day);

        var tomorrow = new Date(today.valueOf());
        //tomorrow.setDate(tomorrow.getDate() + res.data.data.general.defaultDays);

        tomorrow.setDate(today.getDate() + 1);

        if (item.a > 0) {
          if (simple) {
            result += '(' + getMyDate2(item.day, locale) + ') ';
            return '(' + getMyDate2(item.day, locale) + ') ';
          }
          return (
            <Chip
              label={getMyDate2(item.day, locale)}
              style={{ borderRadius: 2, backgroundColor: '#00B294', marginRight: 10 }}
              size="small"
              onClick={() => {
                this.setState({ date1: item.day, date2: getMyDate(tomorrow) }, () => {
                  this.checkOffers();
                });
              }}
            />
          );
        }
        if (item.a == 0) {
          if (simple) return '';
          return (
            <Chip
              size="small"
              label={getMyDate2(item.day, locale)}
              style={{ borderRadius: 2, backgroundColor: '#E74856', marginRight: 10 }}
            />
          );
        }
      }.bind(this),
    );
    if (simple) return result;
    else return res;
  }

  showAvailableTerms2(data, simple = false) {
    const locale = this.context.locale.locale;
    var res2 = (
      <>
        <MyAlert severity="warning">
          <IntlMessages id="noPackageAvailable" />
        </MyAlert>
        <br />
      </>
    );

    var res = data.map(
      function(item) {
        var today = new Date(item.day);

        var tomorrow = new Date(today.valueOf());
        //tomorrow.setDate(tomorrow.getDate() + res.data.data.general.defaultDays);

        tomorrow.setDate(today.getDate() + 1);

        if (item.a > 0) {
          if (simple) return '(' + getMyDate2(item.day1, locale) + ' - ' + getMyDate2(item.day2, locale) + ') ';
          return (
            <Chip
              label={getMyDate2(item.day1, locale) + ' - ' + getMyDate2(item.day2, locale)}
              style={{ borderRadius: 2, backgroundColor: '#00B294', marginRight: 10 }}
              size="small"
              onClick={() => {
                this.setState({ date1: item.day1, date2: item.day2 }, () => {
                  this.checkOffers();
                });
              }}
            />
          );
        }
        if (item.a == 0) if (simple) return '';
        return (
          <Chip
            size="small"
            label={getMyDate2(item.day1, locale) + ' - ' + getMyDate2(item.day2, locale)}
            style={{ borderRadius: 2, backgroundColor: '#E74856', marginRight: 10 }}
          />
        );
      }.bind(this),
    );
    return [res2, res];
  }
  getMealPlan(id) {
    const { intl } = this.props;

    if (id == 0) return intl.formatMessage({ id: 'roomOnly' });
    if (id == 1) return intl.formatMessage({ id: 'breakfastIncluded' });
    if (id == 2) return intl.formatMessage({ id: 'halfBoard' });
    if (id == 3) return intl.formatMessage({ id: 'fullBoard' });
    if (id == 4) return intl.formatMessage({ id: 'allInclusive' });
  }
  getCancelInfo(ci, cit) {
    const locale = this.context.locale.locale;

    if (ci == null || ci == 0) return '';
    var today = new Date();
    //console.log('ci ' + this.state.date1 + ' - ' + ci);
    var lcday = new Date(this.state.date1);
    lcday.setDate(lcday.getDate() - parseInt(ci));
    //console.log(lcday);
    if (lcday > today) return getMyDate2(getMyDate(lcday), locale) + ' ' + cit;
    return '';
  }

  getCancelInfo2(lcday, cit) {
    const locale = this.context.locale.locale;

    return getMyDate2(getMyDate(lcday), locale); // + ' ' + cit;
  }

  checkOffers() {
    const date1 = new Date(this.state.date1);
    const date2 = new Date(this.state.date2);
    const diffTime = Math.abs(date2 - date1);
    var nights = dateDiffInDays(date2, date1); //Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    var hotels = this.state.hotelid;
    if (this.state.searchAll) {
      var ho = this.props.auth.authUser.hotels;
      hotels = ho
        .map(function(item) {
          return item['id'];
        })
        .toString();
    }
    //    var myCA = JSON.parse(JSON.stringify(this.state.childAges));
    const senddata = {
      Action: 'getResults',
      Data: {
        hotelId: this.state.hotelId,
        fromDate: getMyDate(this.state.arrival),
        toDate: getMyDate(this.state.departure),
        adults: this.state.adults,
        children: this.state.children,
        childAge: this.state.childAge2.slice(0, this.state.children).toString(),
        coupon: this.state.coupon,
      },
    };

    if (this.props.auth.authUser.clouduser == 0 && this.props.auth.authUser.role == 20) {
      senddata.Data.disableLimit = 0;
      senddata.Data.agencyId = this.props.auth.authUser.agencyId;
    }
    if (this.props.auth.authUser.clouduser == 0 && this.props.auth.authUser.role != 20 && this.props.agencyId != -1) {
      senddata.Data.disableLimit = 0;
      senddata.Data.agencyId = this.props.agencyId;
    }
    this.setState({ loadingResults: true });
    axios.post(`https://secure.webbookingpro.com/bapi/booking.php`, senddata).then(res => {
      if (res.data != null && res.data.data != null) {
        this.setState(
          {
            loadingResults: false,
            nights: nights,
            items: [],
            changed: false,
            results: res.data.data,
          },
          () => {},
        );
      } else {
        this.setState(
          {
            loadingResults: false,
            nights: nights,
            items: [],
            changed: false,
            results: [],
          },
          () => {},
        );
      }
    });
  }

  checkDates() {
    // if (this.state.rooms < 0) return;
    if (getMyDate(this.state.arrival) >= getMyDate(this.state.departure)) return;
    //if (this.state.adults == '') return;
    //if (this.state.childre == '') return;
    //if (this.state.rooms == '') return;
    //this.props.moveFolio(this.state.folioId);
    //const token = localStorage.getItem('token');
    //var pmsUrl = `https://secure.webbookingpro.com/api/pms.php`;

    const senddata = {
      Action: 'getHotelInfo',
      Data: {
        hotelId: this.state.hotelId,
        full: 1,
      },
    };
    axios.post(`https://secure.webbookingpro.com/bapi/booking.php`, senddata).then(res => {
      if (res.data != null && res.data.data != null) {
        this.setState({
          hotelInfo: res.data.data,
        });
      }
    });
    return;

    /*  const senddata = {
      Action: 'modifyInfo',
      token: token,
      Data: {
        reservationRoomId: this.props.resRoom.brid,
        reservationId: this.props.resRoom.id,
        rooms: this.state.rooms,
        roomId: this.state.roomId,
        arrival: getMyDate(this.state.arrival),
        departure: getMyDate(this.state.departure),
        adults: this.state.adults,
        children: this.state.children,
        rate_id: this.props.resRoom.rate_id,
        meal_plan_id: this.props.resRoom.meal_plan_id,
        childAge: this.state.childAge2.slice(0, this.state.children).toString(),
      },
    };
    axios.post(pmsUrl, senddata).then(res => {
      //  this.props.doRefresh();
      //   alert(JSON.stringify(res.data));
      var newPrice = res.data.newPrice;
      if (this.state.appDiscount != 0) newPrice = newPrice * (1 - this.state.appDiscount / 100);
      this.setState({ newPrice: newPrice, available: res.data.available });
    });*/
  }
  handleClickOpen() {
    //  setOpen(true);
  }

  showChips(rateId) {
    const locale = this.context.locale.locale;
    var x = this.state.results.filter(function(item) {
      return item.rateId == rateId && item.maxRooms > 0 && item.upsell == 0;
    });
    const { intl } = this.props;
    var result = [];
    if (x.length > 0) {
      var sitem = x[0];
      result.push(
        <Chip
          className={'wbpMealPlan'}
          style={{
            backgroundColor: '#ffffff',
            border: '1px solid #E1E1E1',
            borderRadius: 4,
            marginRight: 5,
            marginBottom: 5,
            marginTop: 5,
          }}
          size="small"
          label={this.getMealPlan(x[0].mealPlan)}
        />,
      );

      if (sitem.freeCancel != '')
        result.push(
          <Chip
            className={'wbpFreeCancellation'}
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #E1E1E1',
              borderRadius: 4,
              marginRight: 5,
              marginBottom: 5,
            }}
            size="small"
            label={intl.formatMessage({ id: 'freeCancellation' }) + this.getCancelInfo2(sitem.freeCancel, '15:00')}
          />,
        );
      if (sitem.partialCancel != null && sitem.partialCancel != '')
        result.push(
          <Chip
            className={'wbpPartialCancellation'}
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #E1E1E1',
              borderRadius: 4,
              marginBottom: 5,
              marginRight: 5,
            }}
            size="small"
            label={intl.formatMessage({ id: 'partialCancellation' }) + this.getCancelInfo2(sitem.partialCancel, '15:00')}
          />,
        );
      if (sitem.badge != null && sitem.badge != '')
        result.push(
          <Chip
            className={'wbpBadge'}
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #E1E1E1',
              borderRadius: 4,
              marginBottom: 5,
              marginRight: 5,
            }}
            size="small"
            label={this.getOfferText(sitem.badge)}
          />,
        );
      if (sitem.pbadge[locale] != null && sitem.pbadge[locale] != '')
        result.push(
          <Chip
            className="wbpBadge"
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #E1E1E1',
              borderRadius: 4,
              marginRight: 5,
              marginBottom: 5,
            }}
            size="small"
            label={sitem.pbadge[locale]}
          />,
        );
      if (sitem.policyId == 1)
        result.push(
          <Chip
            className="wbpNonRefundable"
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #E1E1E1',
              borderRadius: 4,
              marginRight: 5,
              marginBottom: 5,
            }}
            size="small"
            label=<IntlMessages id="nonRef" />
          />,
        );
    }
    return result;
  }

  handleChange(name, value, index = -1) {
    if (index != -1 && name == 'roomCount2') {
      this.setState(
        prevState => {
          const roominfos = [...prevState.roomCount2];
          roominfos[index] = value;
          return { roomCount2: roominfos };
        },
        () => {},
      );
      return;
    }
    if (name == 'childAge') {
      this.setState(
        prevState => {
          var va = prevState.childAge2;
          va[index] = value;
          return { childAge2: va, changed: true };
        },
        () => {
          if (name != 'newPrice' && name != 'confirm' && name != 'appDiscount') this.checkDates();
        },
      );
    } else {
      this.setState({ [name]: value, changed: true }, () => {
        if (name != 'newPrice' && name != 'confirm' && name != 'appDiscount') this.checkDates();
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.open != this.props.open) {
      this.setState(
        {
          arrival: this.props.resRoom.checkin,
          departure: this.props.resRoom.checkout,
          hotelId: this.props.resRoom.hotel_id,
          adults: 2,
          children: 0,
          childAge: '',
        },
        () => {
          this.checkDates();
        },
      );
    }
  }

  handleClose() {
    this.props.setState({ addRoomVisible: false });
    //  setOpen(false);
  }

  handleSelect() {
    if (this.state.rooms < 0) return;
    if (getMyDate(this.state.arrival) >= getMyDate(this.state.departure)) return;
    const { intl } = this.props;
    //this.props.moveFolio(this.state.folioId);
    const token = localStorage.getItem('token');
    var pmsUrl = `https://secure.webbookingpro.com/api/pms.php`;
    var reason = '';
    if (this.state.discountMode == 0) reason = this.state.reason;
    else {
      if (this.state.discountMode == 1) reason = intl.formatMessage({ id: 'modify1' });
      if (this.state.discountMode == 2) reason = intl.formatMessage({ id: 'modify2' });
      if (this.state.discountMode == 3) reason = intl.formatMessage({ id: 'modify3' });
      if (this.state.discountMode == 4) reason = intl.formatMessage({ id: 'modify4' });
      if (this.state.discountMode == 5) reason = intl.formatMessage({ id: 'modify5' });
      if (this.state.discountMode == 6) reason = intl.formatMessage({ id: 'modify6' });
      if (this.state.discountMode == 7) reason = intl.formatMessage({ id: 'modify7' });
      if (this.state.discountMode == 8) reason = intl.formatMessage({ id: 'modify8' });
      if (this.state.discountMode == 9) reason = intl.formatMessage({ id: 'modify9' });
      if (this.state.discountMode == 10) reason = intl.formatMessage({ id: 'modify10' });
      if (this.state.discountMode == 11) reason = intl.formatMessage({ id: 'modify11' });
      if (this.state.discountMode == 12) reason = intl.formatMessage({ id: 'modify12' });
      if (this.state.discountMode == 13) reason = intl.formatMessage({ id: 'modify13' });
      if (this.state.discountMode == 14) reason = intl.formatMessage({ id: 'modify14' });
      if (this.state.discountMode == 15) reason = intl.formatMessage({ id: 'modify15' });
    }
    const senddata = {
      Action: 'modifyreservation',
      token: token,
      Data: {
        reservationRoomId: this.props.resRoom.brid,
        reservationId: this.props.resRoom.id,
        rooms: this.state.rooms,
        roomId: this.state.roomId,
        arrival: getMyDate(this.state.arrival),
        departure: getMyDate(this.state.departure),
        adults: this.state.adults,
        children: this.state.children,
        childAge: this.state.childAge2.slice(0, this.state.children).toString(),
        newPrice: this.state.newPrice,
        reason: reason,
        appDiscount: this.state.appDiscount,
      },
    };
    axios.post(pmsUrl, senddata).then(res => {
      if (this.props.setState2 != null) this.props.setState2({ resDetailsVisible: false });
      if (this.props.setState2 != null) this.props.setState2({ lastEvents: [], running2: false });
      this.props.doRefresh();
      //if (this.props.doRefresh != null) this.props.doRefresh();
      this.props.setState({ addRoomVisible: false });
      if (this.props.doRefresh2 != null) this.props.doRefresh2();
    });
  }

  render() {
    const { classes } = this.props;
    var roomtypes = this.props.auth.authUser.roomtypes;
    var userRole = this.props.auth.authUser.role;
    const locale = this.context.locale.locale;
    var disablePrice = false;
    if ([16].includes(userRole)) disablePrice = true;
    return (
      <div>
        <Dialog open={this.props.open} onClose={this.handleClose} maxWidth="xl" TransitionComponent={Transition}>
          <Box sx={style}>
            <PerfectScrollbar className={classes.scrollbarRoot}>
              <Grid container spacing={1}>
                <Grid item xs={6} md={6} xl={6}>
                  <TextField
                    id="type"
                    label=<IntlMessages id="res.adults" />
                    value={this.state.adults}
                    fullWidth
                    disabled={false}
                    onChange={event => this.handleChange('adults', event.target.value)}
                  />
                </Grid>
                <Grid item xs={6} md={6} xl={6}>
                  <TextField
                    id="type"
                    label=<IntlMessages id="res.children" />
                    value={this.state.children}
                    fullWidth
                    disabled={false}
                    onChange={event => this.handleChange('children', event.target.value)}
                  />
                  {this.state.children > 0 && (
                    <Box className={classes.cardContentInner2}>
                      <Typography component="label" className={classes.title}>
                        <IntlMessages id="childAges" />
                        <br />
                      </Typography>
                      {Array(parseInt(this.state.children))
                        .fill()
                        .map((_, ci) => (
                          <TextField
                            id="priceModel"
                            name="priceModel"
                            select
                            variant="outlined"
                            size="small"
                            margin="small"
                            className={classes.currency}
                            value={this.state.childAge2[ci]}
                            onChange={event => this.handleChange('childAge', event.target.value, ci)}>
                            {Array(18)
                              .fill()
                              .map((_, idx) => (
                                <MenuItem value={idx}>{idx}</MenuItem>
                              ))}
                          </TextField>
                        ))}
                    </Box>
                  )}
                </Grid>

                <Grid item xs={6} md={6} xl={6}>
                  <FormControl variant="filled" className={classes.formControl}>
                    <DatePicker
                      variant="inline"
                      format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                      margin="normal"
                      id="date1"
                      name="date1"
                      label={<IntlMessages id="res.arrival" />}
                      autoOk="true"
                      value={this.state.arrival}
                      onChange={date => {
                        this.setState({ arrival: date, changed: true }, () => {
                          this.checkDates();
                          //if (cloudUser == 0) this.checkOffers();
                        });
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6} xl={6}>
                  <FormControl variant="filled" className={classes.formControl}>
                    <DatePicker
                      variant="inline"
                      format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                      margin="normal"
                      id="date1"
                      name="date1"
                      label={<IntlMessages id="res.departure" />}
                      autoOk="true"
                      value={this.state.departure}
                      onChange={date => {
                        this.setState({ departure: date, changed: true }, () => {
                          this.checkDates();
                          //if (cloudUser == 0) this.checkOffers();
                        });
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.myButton}
                    onClick={() => this.checkOffers()}
                    fullWidth>
                    <IntlMessages id="findOffers" />
                  </Button>
                </Grid>

                {this.state.available == 0 && this.state.loadingResults == false && this.state.changed == false && (
                  <Grid item xs={12}>
                    <MyAlert severity="warning">
                      <IntlMessages id="_NO_AVAILABLE_ROOMS" />
                    </MyAlert>
                  </Grid>
                )}
                {this.state.loadingResults == true && (
                  <Grid item xs={12} xl={12} md={12}>
                    <>
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </>
                  </Grid>
                )}
                {this.state.loadingResults == false &&
                  this.state.changed == false &&
                  this.props.auth.authUser.services
                    .filter(
                      function(itemx) {
                        return itemx.hotelid == this.state.hotelId && itemx.ID > 0;
                      }.bind(this),
                    )
                    .map(
                      function(serviceItem, serviceItemIndex) {
                        return [
                          this.state.results.filter(
                            function(sitem) {
                              var show = true;

                              if (this.state.hideUnavailable && sitem.maxRooms == 0) show = false;

                              if (sitem.upsell == 1) show = false;

                              if (sitem.roomId == 0) show = false;

                              if (this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == sitem.roomId).length == 0)
                                return;

                              var hotelId = this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == sitem.roomId)[0]
                                .hotelid;
                              if (hotelId != serviceItem.hotelid) show = false;

                              if (sitem.rateId != 0 && sitem.rateId != null /* && serviceItemIndex > 0*/) show = false;

                              return (sitem.serviceId == serviceItem.ID || sitem.serviceId == 0) && show;
                            }.bind(this),
                          ).length > 0 && (
                            <Grid item xs={12} xl={12} md={12}>
                              <AppBar className={classes.appBar}>
                                {this.state.searchAll == true &&
                                  this.props.auth.authUser.hotels.find(({ id }) => id === serviceItem.hotelid).name + ': '}
                                {serviceItem.Name}
                              </AppBar>
                            </Grid>
                          ),
                          this.state.results
                            .filter(
                              function(sitem) {
                                var show = true;
                                if (this.state.hideUnavailable && sitem.maxRooms == 0) show = false;
                                if (sitem.upsell == 1) show = false;
                                if (this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == sitem.roomId).length == 0)
                                  return;

                                var hotelId = this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == sitem.roomId)[0]
                                  .hotelid;
                                if (hotelId != serviceItem.hotelid) show = false;
                                if (sitem.rateId != 0 && sitem.rateId != null /* && serviceItemIndex > 0*/) show = false;
                                return (sitem.serviceId == serviceItem.ID || sitem.serviceId == 0) && show;
                              }.bind(this),
                            )

                            .sort(
                              function(r1item, r2item) {
                                if (this.state.showAvailableFirst == 1) {
                                  const m1a = this.state.results.filter(function(sitem) {
                                    return sitem.roomId == r1item.id && sitem.serviceId != null;
                                  });

                                  const m2a = this.state.results.filter(function(sitem) {
                                    return sitem.roomId == r2item.id && sitem.serviceId != null;
                                  });
                                  var m1 = 0,
                                    m2 = 0;
                                  if (m1a.length > 0) m1 = m1a[0].maxRooms;
                                  if (m2a.length > 0) m2 = m2a[0].maxRooms;
                                  //console.log(r1item, r2item, m1, m2);
                                  if (m1 > 1) m1 = 1;
                                  if (m2 > 1) m2 = 1;

                                  return m2 - m1;
                                } else return 0;
                              }.bind(this),
                            )
                            .map(
                              function(sitem, sindex) {
                                //console.log(sitem);
                                if (sitem.maxRooms == 0) {
                                  //console.log('tuxx');
                                  return [
                                    <Grid item xs={12} xl={12} md={12}>
                                      {this.state.isAgency == false && (
                                        <Checkbox
                                          color="primary"
                                          checked={this.state.selected[sitem.index]}
                                          onChange={event =>
                                            this.handleChange('selected', event.target.checked, sitem.index)
                                          }
                                        />
                                      )}
                                      {this.props.auth.authUser.roomtypes.find(({ ID }) => ID == sitem.roomId).Name}
                                    </Grid>,
                                    <Grid item xs={12} xl={12} md={12}>
                                      {this.showRoomMessage(0)}
                                      {this.showRoomMessage2(sitem.messageId)}
                                      {this.showAvailableTerms(sitem.availableDays)}
                                    </Grid>,
                                  ];
                                }

                                if (sitem.maxRooms > 0)
                                  return (
                                    <>
                                      <Grid item xs={12} xl={4} md={4}>
                                        {this.state.isAgency == false && (
                                          <Checkbox
                                            color="primary"
                                            checked={this.state.selected[sitem.index]}
                                            onChange={event =>
                                              this.handleChange('selected', event.target.checked, sitem.index)
                                            }
                                          />
                                        )}
                                        {this.props.auth.authUser.roomtypes.find(({ ID }) => ID == sitem.roomId).Name}
                                        {sitem.policyId == 1 && (
                                          <>
                                            <br />
                                            <IntlMessages id="nonRef" />
                                          </>
                                        )}
                                      </Grid>
                                      <Grid item xs={6} xl={4} sm={4}>
                                        {sitem.priceOriginal != sitem.priceFinal && (
                                          <strike>
                                            {this.getRoomPrice(sitem.priceOriginal, sitem.currency)}
                                            <br />
                                          </strike>
                                        )}
                                        {this.getRoomPrice(sitem.priceFinal, sitem.currency)}
                                        <br />
                                      </Grid>
                                      <Grid item xs={6} xl={2} sm={2}>
                                        {sitem.maxRooms > 1 && (
                                          <>
                                            <TextField
                                              id="priceModel"
                                              name="priceModel"
                                              select
                                              variant="outlined"
                                              size="small"
                                              margin="small"
                                              className={classes.combo2}
                                              value={this.state.roomCount2[sitem.index]}
                                              onChange={event =>
                                                this.handleChange('roomCount2', event.target.value, sitem.index)
                                              }>
                                              {Array(sitem.maxRooms)
                                                .fill()
                                                .map((_, idx) => (
                                                  <MenuItem value={idx + 1}>{idx + 1}</MenuItem>
                                                ))}
                                            </TextField>
                                          </>
                                        )}
                                      </Grid>
                                      <Grid item xs={6} xl={2} md={2}>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          size="small"
                                          fullWidth
                                          onClick={() => this.useOffer(sitem)}>
                                          <IntlMessages id="addRoom2" />
                                        </Button>
                                      </Grid>
                                    </>
                                  );
                              }.bind(this),
                            ),
                        ];
                      }.bind(this),
                    )}
                {this.state.loadingResults == false &&
                  this.state.changed == false &&
                  this.props.auth.authUser.rates != null &&
                  this.props.auth.authUser.rates
                    .filter(
                      function(itemx) {
                        return itemx.hotel_id == this.state.hotelId || this.state.searchAll;
                      }.bind(this),
                    )
                    .map(
                      function(serviceItem, serviceItemIndex) {
                        return [
                          this.state.results.filter(
                            function(sitem) {
                              var show = true;
                              if (this.state.hideUnavailable && sitem.maxRooms == 0) show = false;

                              if (sitem.upsell == 1) show = false;

                              if (this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == sitem.roomId).length == 0)
                                return;

                              var hotelId = this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == sitem.roomId)[0]
                                .hotelid;

                              if (hotelId != serviceItem.hotel_id) show = false;

                              //if (sitem.rateId != 0 && sitem.rateId != null /* && serviceItemIndex > 0*/) show = false;

                              return sitem.rateId == serviceItem.id && show;
                            }.bind(this),
                          ).length > 0 && (
                            <Grid item xs={12} xl={12} md={12}>
                              <AppBar className={classes.appBar}>
                                {this.state.searchAll == true &&
                                  serviceItem.hotel_id != null &&
                                  this.props.auth.authUser.hotels.find(({ id }) => id == serviceItem.hotel_id) != null &&
                                  this.props.auth.authUser.hotels.find(({ id }) => id == serviceItem.hotel_id).name + ': '}
                                {this.state.searchAll == true &&
                                  serviceItem.hotelId != null &&
                                  this.props.auth.authUser.hotels.find(({ id }) => id == serviceItem.hotelId) != null &&
                                  this.props.auth.authUser.hotels.find(({ id }) => id == serviceItem.hotelId).name + ': '}
                                {serviceItem.name}
                              </AppBar>
                              {this.showChips(serviceItem.id)}
                            </Grid>
                          ),
                          this.state.results
                            .filter(
                              function(sitem) {
                                var show = true;
                                if (this.state.hideUnavailable && sitem.maxRooms == 0) show = false;
                                //console.log('show1=' + show);
                                if (sitem.upsell == 1) show = false;
                                //console.log('show2=' + show);
                                if (this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == sitem.roomId).length == 0)
                                  return;

                                var hotelId = this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == sitem.roomId)[0]
                                  .hotelid;
                                if (hotelId != serviceItem.hotel_id) show = false;
                                //console.log('show3=' + show);
                                //if (sitem.rateId != 0 && sitem.rateId != null /* && serviceItemIndex > 0*/) show = false;
                                //console.log('show4=' + show);
                                //console.log(sitem.rateId);
                                //console.log(serviceItem.id);
                                return sitem.rateId == serviceItem.id && show;
                              }.bind(this),
                            )

                            .sort(
                              function(r1item, r2item) {
                                if (this.state.showAvailableFirst == 1) {
                                  const m1a = this.state.results.filter(function(sitem) {
                                    return sitem.roomId == r1item.id && sitem.rateId != null;
                                  });

                                  const m2a = this.state.results.filter(function(sitem) {
                                    return sitem.roomId == r2item.id && sitem.rateId != null;
                                  });
                                  var m1 = 0,
                                    m2 = 0;
                                  if (m1a.length > 0) m1 = m1a[0].maxRooms;
                                  if (m2a.length > 0) m2 = m2a[0].maxRooms;
                                  //console.log(r1item, r2item, m1, m2);
                                  if (m1 > 1) m1 = 1;
                                  if (m2 > 1) m2 = 1;

                                  return m2 - m1;
                                } else return 0;
                              }.bind(this),
                            )
                            .map(
                              function(sitem, sindex) {
                                //console.log(sitem);
                                if (sitem.maxRooms == 0) {
                                  //console.log('tuxx');
                                  return [
                                    <Grid item xs={12} xl={12} md={12}>
                                      {this.state.isAgency == false && (
                                        <Checkbox
                                          color="primary"
                                          checked={this.state.selected[sitem.index]}
                                          onChange={event =>
                                            this.handleChange('selected', event.target.checked, sitem.index)
                                          }
                                        />
                                      )}
                                      {this.props.auth.authUser.roomtypes.find(({ ID }) => ID == sitem.roomId).Name}
                                    </Grid>,
                                    <Grid item xs={12} xl={12} md={12}>
                                      {this.showRoomMessage(0)}
                                      {this.showRoomMessage2(sitem.messageId)}
                                      {this.showAvailableTerms(sitem.availableDays)}
                                    </Grid>,
                                  ];
                                }

                                if (sitem.maxRooms > 0)
                                  return (
                                    <>
                                      <Grid item xs={12} xl={4} md={4}>
                                        {this.state.isAgency == false && (
                                          <Checkbox
                                            color="primary"
                                            checked={this.state.selected[sitem.index]}
                                            onChange={event =>
                                              this.handleChange('selected', event.target.checked, sitem.index)
                                            }
                                          />
                                        )}
                                        {this.props.auth.authUser.roomtypes.find(({ ID }) => ID == sitem.roomId).Name}
                                        {sitem.policyId == 1 && (
                                          <>
                                            <br />
                                            <IntlMessages id="nonRef" />
                                          </>
                                        )}
                                      </Grid>
                                      <Grid item xs={6} xl={4} sm={4}>
                                        {sitem.priceOriginal != sitem.priceFinal && (
                                          <strike>
                                            {this.getRoomPrice(sitem.priceOriginal, sitem.currency)}
                                            <br />
                                          </strike>
                                        )}
                                        {this.getRoomPrice(sitem.priceFinal, sitem.currency)}
                                        <br />
                                      </Grid>
                                      <Grid item xs={6} xl={2} sm={2}>
                                        {sitem.maxRooms > 1 && (
                                          <>
                                            <TextField
                                              id="priceModel"
                                              name="priceModel"
                                              select
                                              variant="outlined"
                                              size="small"
                                              margin="small"
                                              className={classes.combo2}
                                              value={this.state.roomCount2[sitem.index]}
                                              onChange={event =>
                                                this.handleChange('roomCount2', event.target.value, sitem.index)
                                              }>
                                              {Array(sitem.maxRooms)
                                                .fill()
                                                .map((_, idx) => (
                                                  <MenuItem value={idx + 1}>{idx + 1}</MenuItem>
                                                ))}
                                            </TextField>
                                          </>
                                        )}
                                      </Grid>
                                      <Grid item xs={6} xl={2} md={2}>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          size="small"
                                          fullWidth
                                          onClick={() => this.useOffer(sitem)}>
                                          <IntlMessages id="addRoom2" />
                                        </Button>
                                      </Grid>
                                    </>
                                  );
                              }.bind(this),
                            ),
                        ];
                      }.bind(this),
                    )}

                {this.state.loadingResults == false &&
                  this.state.changed == false &&
                  this.state.hotelInfo.packages != null &&
                  this.state.hotelInfo.packages
                    .filter(
                      function(itemx) {
                        return itemx.hotelId == this.state.hotelId && itemx.nights == this.state.nights;
                      }.bind(this),
                    )
                    .map(
                      function(serviceItem) {
                        return [
                          <Grid item xs={12} xl={12} md={12}>
                            <AppBar className={classes.appBar}>{serviceItem.title[locale]}</AppBar>
                          </Grid>,
                          this.state.results
                            .filter(function(sitem) {
                              return sitem.packageId == serviceItem.id;
                            })
                            .map(
                              function(sitem, sindex) {
                                //console.log(sitem);
                                if (sitem.maxRooms == 0) {
                                  //console.log('tuxx');
                                  return [
                                    <Grid item xs={12} xl={12} md={12}>
                                      <Checkbox
                                        color="primary"
                                        checked={this.state.selected[sitem.index]}
                                        onChange={event => this.handleChange('selected', event.target.checked, sitem.index)}
                                      />
                                      {this.props.auth.authUser.roomtypes.find(({ ID }) => ID == sitem.roomId).Name}
                                    </Grid>,
                                    <Grid item xs={12} xl={12} md={12}>
                                      {this.showRoomMessage(0)}
                                      {this.showRoomMessage2(sitem.messageId)}
                                      {this.showAvailableTerms2(sitem.availableDays)}
                                    </Grid>,
                                  ];
                                }

                                if (sitem.maxRooms > 0)
                                  return (
                                    <>
                                      <Grid item xs={12} xl={5} md={5}>
                                        <Checkbox
                                          color="primary"
                                          checked={this.state.selected[sitem.index]}
                                          onChange={event =>
                                            this.handleChange('selected', event.target.checked, sitem.index)
                                          }
                                        />
                                        {this.props.auth.authUser.roomtypes.find(({ ID }) => ID == sitem.roomId).Name}
                                        {sitem.policyId == 1 && (
                                          <>
                                            <br />
                                            <IntlMessages id="nonRef" />
                                          </>
                                        )}
                                      </Grid>
                                      <Grid item xs={6} xl={3} sm={3}>
                                        {this.getRoomPrice(sitem.priceFinal, sitem.currency)}
                                        <br />
                                      </Grid>
                                      <Grid item xs={6} xl={2} sm={2}>
                                        {sitem.maxRooms > 1 && (
                                          <>
                                            <TextField
                                              id="priceModel"
                                              name="priceModel"
                                              select
                                              variant="outlined"
                                              size="small"
                                              margin="small"
                                              className={classes.combo2}
                                              value={this.state.roomCount2[sitem.index]}
                                              onChange={event =>
                                                this.handleChange('roomCount2', event.target.value, sitem.index)
                                              }>
                                              {Array(sitem.maxRooms)
                                                .fill()
                                                .map((_, idx) => (
                                                  <MenuItem value={idx + 1}>{idx + 1}</MenuItem>
                                                ))}
                                            </TextField>
                                          </>
                                        )}
                                      </Grid>
                                      <Grid item xs={6} xl={2} md={2}>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          size="small"
                                          fullWidth
                                          onClick={() => this.useOffer(sitem)}>
                                          <IntlMessages id="addRoom2" />
                                        </Button>
                                      </Grid>
                                    </>
                                  );
                              }.bind(this),
                            ),
                        ];
                      }.bind(this),
                    )}

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.myButton}
                    onClick={() => this.handleClose()}
                    fullWidth>
                    <IntlMessages id="findClient.cancel" />
                  </Button>
                </Grid>
              </Grid>
            </PerfectScrollbar>
          </Box>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};
AddRoom.contextType = AppContext;

export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(AddRoom)));
